import { classNamesFor } from '../../../utils/classNames';
import {
  statusChipColors,
  statusChipSizes,
  statusChipVariants,
} from './constants';

const factory = classNamesFor('StatusChip');

export const statusChipClassNames = {
  root: factory.root(),
  label: factory.element('label'),
  caption: factory.element('caption'),
  labelGroup: factory.element('labelGroup'),
  icon: factory.element('icon'),
  spinner: factory.element('spinner'),
  ...factory.toAttrClasses('color', statusChipColors),
  ...factory.toAttrClasses('size', statusChipSizes),
  ...factory.toAttrClasses('variant', statusChipVariants),
};
